<template>
  <div class="container">
    <div class="card">
      <div class="card-header">
        <div class="card-title">
          <fai icon="user"/>&nbsp;Registrar Anexo
        </div>
      </div>
      <div class="card-body pb-5">
        <!--begin: Details -->
          <div class="row mt-4">
            <div class="col-sm-6">
              <h4 class="font-info">Datos Generales</h4>
            </div>
          </div>
          <sys-form :inputs="attachment_details" />
        <!--end: Details -->
      </div>
      <div class="card-footer text-right">
        <button class="btn btn-secondary" @click="$router.push({ name: 'attachments' })">
          <fai icon="reply"/> Cancelar
        </button>
        <button class="btn btn-success" :class="{ 'disabled': form.isSaving }" @click="saveForm">
          <fai :icon="['far','edit']"/> Guardar
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import attachmentsService from '@/services/attachments'
import investorsService from '@/services/investors'
import SysForm from '@/components/shared/Form'
import formMixin from '@/mixins/form'

export default {
  name: 'AttachmentCreate',

  components: { SysForm },

  mixins: [ formMixin ],

  data () {
    return {
      loaded: false,
      attachment: {},
      attachment_details: {
        investor_id: {
          name: 'Acreedor',
          value: '',
          type: 'select',
          options: [],
          size: 12,
          validate: 'required'
        },
        contract_id: {
          name: 'Contrato',
          value: '',
          type: 'select',
          options: [],
          size: 12,
          validate: 'required'
        },
        cut_day: {
          name: 'Día de corte',
          hint: 'Día de corte',
          type: 'select',
          options: [],
          disabled: true
        },
        interest_rate: {
          name: 'Tasa de Interés',
          hint: '5%',
          min: 0,
          max: 100,
          type: 'number',
          disabled: true
        },
        frequency: {
          name: 'Frecuencia de Pago',
          type: 'select',
          options: [],
          disabled: true
        },
        date_start: {
          name: 'Fecha de Registro',
          hint: 'dd/mm/aaaa',
          value: '',
          type: 'date'
        },
        date_init: {
          name: 'Fecha de Pago',
          hint: 'dd/mm/aaaa',
          value: '',
          type: 'date',
          validate: 'required'
        },
        date_expire: {
          name: 'Fecha de Expiración',
          hint: 'dd/mm/aaaa',
          value: '',
          type: 'date',
          validate: 'required'
        },
        amount: {
          name: 'Monto del Anexo',
          hint: 'Monto del Anexo',
          value: '',
          type: 'number',
          min: 0,
          validate: 'required'
        },
        type: {
          name: 'Tipo de Anexo',
          hint: 'Tipo de Movimiento',
          type: 'select',
          options: [{ value: 'Inicial', text: 'Inicial' }, { value: 'Incremento', text: 'Incremento' }, { value: 'Retiro', text: 'Retiro' }, { value: 'Renovacion', text: 'Renovacion' }]
        },
        state: {
          name: 'Estatus de Anexo',
          hint: 'Estatus',
          type: 'select',
          options: [{ value: 'Registrado', text: 'Registrado', selected: true }, { value: 'En firma', text: 'En firma' }, { value: 'En archivo', text: 'En archivo' }, { value: 'Pagaré Cancelado', text: 'Pagaré Cancelado' }]
        },
        attachment_id: {
          name: 'Id del Anexo',
          hint: 'Id del Anexo',
          value: '',
          type: 'number',
          validate: 'required'
        }
      },
      contracts: {}
    }
  },

  created: function () {
    this.loaded = false

    attachmentsService.getById(this.$route.params.id).then(res => {
      this.attachment = res.data

      this.attachment_details.date_start.value = (this.attachment.date_start != null) ? this.attachment.date_start.split('-').reverse().join('-') : null
      this.attachment_details.date_init.value = this.attachment.date_init.split('-').reverse().join('-')
      this.attachment_details.attachment_id.value = this.attachment.attachment_id
      this.attachment_details.date_expire.value = this.attachment.date_expire.split('-').reverse().join('-')
      this.attachment_details.amount.value = this.attachment.amount
      this.attachment_details.type.value = this.attachment.type
      this.attachment_details.state.value = this.attachment.state

      this.attachment_details.investor_id.value = {
        value: this.attachment.investor_id,
        text: this.attachment.investor_name
      }

      this.attachment_details.contract_id.value = {
        value: this.attachment.contract_id,
        text: this.attachment.contract_folio
      }

      this.attachment_details.cut_day.value = {
        value: this.attachment.cut_day,
        text: this.attachment.cut_day
      }

      this.attachment_details.interest_rate.value = this.attachment.interest_rate

      this.attachment_details.frequency.value = {
        value: this.attachment.frequency,
        text: this.attachment.frequency
      }
    })
  },

  methods: {
    saveForm: function () {
      this.$validator.validateAll().then((result) => {
        if (result) {
          let body = this.processForm(this.attachment_details)
          let service = attachmentsService.updateById(this.attachment.id, body)

          this.sendForm(service).then(res => {
            this.$router.push({ name: 'attachment', id: { id: this.attachment.id } })
          }).catch(err => {
            console.log(JSON.stringify(err))
          })
        }
      })
    }
  },

  watch: {
    'attachment_details.investor_id.value': function (newInvestor) {
      if (this.loaded) this.attachment_details.contract_id.value = { value: null, text: 'Seleccione un Contrato' }
      else this.loaded = true

      if (!newInvestor.value) return

      investorsService.contracts(newInvestor.value).then(res => {
        this.attachment_details.contract_id.options = res.map(contract => {
          return {
            value: contract.id,
            text: contract.folio,
            cut_day: contract.cut_day,
            interest_rate: contract.interest_rate,
            frequency: contract.frequency_name
          }
        })
      })
    },

    'attachment_details.contract_id.value': function (newContract, oldContract) {
      if (!newContract.value) {
        this.attachment_details.cut_day.value = ''
        this.attachment_details.interest_rate.value = ''
        this.attachment_details.frequency.value = ''
        return
      }

      if (oldContract !== '') {
        this.attachment_details.cut_day.value = {
          value: newContract.cut_day,
          text: newContract.cut_day
        }

        this.attachment_details.interest_rate.value = newContract.interest_rate

        this.attachment_details.frequency.value = {
          value: newContract.frequency,
          text: newContract.frequency
        }
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/attachments/AttachmentUpdate.vue